/**
 * COMING SOON restock notify.
 * gltheaa-restock-trigger: button shown in place of the cart button.
 *   data-variant-id = row variant; empty = variant currently selected in the picker.
 * gltheaa-restock-dialog: modal that posts to the gltheaa app proxy
 *   (same payload as the app block's restock-notify).
 */
class GltheaaRestockDialog extends HTMLElement {
  connectedCallback() {
    try {
      this.strings = JSON.parse(this.dataset.strings || '{}');
    } catch (_e) {
      this.strings = {};
    }
    this.modal = this.querySelector('[data-restock-modal]');
    this.form = this.querySelector('[data-restock-form]');
    this.email = this.querySelector('[data-restock-email]');
    this.hp = this.querySelector('[data-restock-hp]');
    this.submit = this.querySelector('[data-restock-submit]');
    this.status = this.querySelector('[data-restock-status]');
    this.openedAt = 0;

    this.onSubmit = this.onSubmit.bind(this);
    this.onBackdrop = this.onBackdrop.bind(this);
    this.close = this.close.bind(this);
    this.form.addEventListener('submit', this.onSubmit);
    this.modal.addEventListener('click', this.onBackdrop);
    this.querySelector('[data-restock-close]')?.addEventListener('click', this.close);
  }

  open(variantId) {
    const radio = Array.from(this.querySelectorAll('input[name="restock-variant"]')).find(
      (input) => input.value === String(variantId)
    );
    if (radio) radio.checked = true;
    this.setStatus('');
    this.submit.disabled = false;
    this.openedAt = Date.now();
    this.modal.showModal();
  }

  close() {
    this.modal.close();
  }

  onBackdrop(event) {
    if (event.target === this.modal) this.close();
  }

  setStatus(message, tone) {
    this.status.hidden = !message;
    this.status.textContent = message || '';
    this.status.setAttribute('data-tone', tone || 'info');
  }

  errorMessage(code) {
    const map = {
      invalid_email: this.strings.invalidEmail,
      email_required: this.strings.emailRequired,
      rate_limited: this.strings.rateLimited,
      disabled: this.strings.disabled,
    };
    return map[code] || this.strings.error;
  }

  async onSubmit(event) {
    event.preventDefault();
    const email = this.email.value.trim();
    if (!email) return this.setStatus(this.errorMessage('email_required'), 'error');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.setStatus(this.errorMessage('invalid_email'), 'error');

    const checked = this.querySelector('input[name="restock-variant"]:checked');
    this.submit.disabled = true;
    this.setStatus('');

    try {
      const response = await fetch(this.dataset.subscribeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          productId: this.dataset.productId,
          variantId: checked ? checked.value : null,
          email,
          locale: this.dataset.locale,
          hp: this.hp.value,
          t: Date.now() - this.openedAt,
          turnstileToken: '',
        }),
      });
      const data = await response.json();
      if (data && data.ok) {
        this.setStatus(data.already ? this.strings.already : this.strings.success, 'success');
      } else {
        this.setStatus(this.errorMessage(data && data.error), 'error');
      }
    } catch (_e) {
      this.setStatus(this.strings.error, 'error');
    }
    this.submit.disabled = false;
  }
}

class GltheaaRestockTrigger extends HTMLElement {
  connectedCallback() {
    this.onClick = this.onClick.bind(this);
    this.querySelector('button')?.addEventListener('click', this.onClick);
  }

  selectedVariantId() {
    const script = document.querySelector(`#variant-selects-${this.dataset.sectionId} [data-selected-variant]`);
    try {
      return JSON.parse(script.textContent).id;
    } catch (_e) {
      return this.dataset.fallbackVariantId;
    }
  }

  onClick() {
    const dialog = document.getElementById(`GltheaaRestock-${this.dataset.sectionId}`);
    dialog?.open(this.dataset.variantId || this.selectedVariantId());
  }
}

if (!customElements.get('gltheaa-restock-dialog')) {
  customElements.define('gltheaa-restock-dialog', GltheaaRestockDialog);
}
if (!customElements.get('gltheaa-restock-trigger')) {
  customElements.define('gltheaa-restock-trigger', GltheaaRestockTrigger);
}
